import React from "react";

import { OrderModel } from "api";
import { ORDERS } from "util/featureFlags";
import useFeatureFlag from "hooks/useFeatureFlag";
import usePermission from "hooks/usePermission";
import ContractTabTable from "components/SortableTable/SortableStripedTable";

export const ordersColumns: ColumnDefinition<
  OrderModel & {
    ShippingStatus: string;
    "DocumentLines.WarehouseCode": "string";
  }
>[] = [
  {
    property: "releaseNumber",
    sortKey: "ReleaseNumber",
    columnLabel: "Release #",
  },
  {
    property: "quantityFormatted",
    sortKey: "CalculatedSumQuantity",
    columnLabel: "Quantity",
  },
  {
    property: "shipFrom",
    //sortKey: "DocumentLines.WarehouseCode", // TODO: needs API work [IRM-103]. Does not work
    columnLabel: "Ship From",
  },
  {
    property: "shipTo",
    sortKey: "ShipToCode",
    columnLabel: "Ship To",
    hideTooltip: true,
  },
  {
    property: "poNumber",
    sortKey: "NumAtCard",
    columnLabel: "PO #",
    hideTooltip: true,
  },
  {
    property: "mode",
    sortKey: "ModeOfTransportationCode",
    columnLabel: "Mode",
  },
  {
    property: "shipped",
    sortKey: "ShippingStatus",
    columnLabel: "Status",
  },
];

const OrdersTable = ({
  orders,
}: {
  orders: ContractTerms;
}): React.ReactElement => {
  const hasEditOrderFlag = useFeatureFlag(ORDERS.EDIT);
  const hasEditOrderPermission = usePermission(ORDERS.EDIT);

  return (
    <ContractTabTable
      values={orders}
      columns={[
        ...ordersColumns,
        ...(hasEditOrderFlag && hasEditOrderPermission
          ? [
              {
                property: "edit",
                columnLabel: "",
                hideTooltip: true,
              },
            ]
          : []),
      ]}
    />
  );
};

export default OrdersTable;
